var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8.89327 4.43555c-.65658.28725-1.31316.65658-1.88767 1.06694l.20518 1.9287c.12311 1.10797-.5745 2.33906-1.60041 2.79041l-1.72351.7797c-.04104.6156-.04104 1.5594 0 2.216l1.72351.7797c1.02591.4514 1.72352 1.6414 1.60041 2.7904l-.20518 1.9287c.57451.4514 1.19005.8208 1.88767 1.067l1.55933-1.149c.4514-.3283 1.0259-.4925 1.6005-.4925.5745 0 1.149.1642 1.6004.4925l1.5593 1.149c.6566-.2873 1.3132-.6566 1.8877-1.067l-.2052-1.9287c-.1231-1.1079.5745-2.339 1.6004-2.7904l1.7235-.7797c.0411-.6156.0411-1.5594 0-2.216l-1.7235-.7797c-1.0259-.45135-1.7235-1.6414-1.6004-2.79041l.2052-1.9287c-.5745-.4514-1.19-.82073-1.8877-1.06694l-1.5593 1.14901c-.4514.32829-1.0259.49243-1.6004.49243-.5746 0-1.1491-.16414-1.6005-.49243z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.cc4a514ec781f41876f984bd526cc17c.svg";
export { ForwardRef as ReactComponent };